// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xceXq","name":"Header_name__2mH-c","birthday":"Header_birthday__2iccg","skeleton":"Header_skeleton__18rKp"};